export default __webpack_public_path__ + "static/media/ionic.646bc1e0.png";